<template>
    <!-- Book Assigned -->
    <div @click="changeGeneralShowCalendar">
        <v-card
            v-if="bookCatalog&&!loading"
            data-cy="assignedBook-container"
            elevation="0"
            class="bg-purple book-card-carousel"
            width="100%"
            dark
        >
            <v-row class="px-4 py-4 ma-0 flex-nowrap carousel-wrap" justify="center">
                <v-col cols="auto pl-0 py-0" v-if="bookCatalog.book">
                <!-- <v-col cols="12" md="4"> -->
                    <v-img
                        :src="
                            `${$utils.globalConstants.BASE_ASSETS_URL}/lbr/image/${bookCatalog.book.resourceDir}/cover_small.jpg`
                        "
                        @click="$router.push(`/user/book/${bookCatalog.book.id}`)"
                        class="book-img cursor-pointer rounded"
                        :height="$vuetify.breakpoint.md ? '205' : '160'"
                        :width="$vuetify.breakpoint.md ? '150' : '125'"
                    />
                </v-col>
                <v-col cols="auto" class="text-left py-0 pr-0 flex-fill" v-if="bookCatalog&&!loading">
                <!-- <v-col cols="12" md="8"> -->
                    <span class="book-tag mb-2">{{ $t('home.assigned_book') }}</span>
                    <h4 v-if="bookCatalog.book" class="mb-2">{{ bookCatalog.book.title }} </h4>
                    <!-- <p class="mb-1 truncate-overflow"> {{ book.bookAbstract }} </p> -->
                    <!-- progress bar fecha -->
                    <div class="progress-bar mb-1">
                        <label for="">{{ $t('home.end_date') }}</label>
                        <div class="progress-bar__container">
                        <v-progress-linear
                            background-color="#514585"
                            color="#C4BBE7"
                            :value="completedTasksPercentageDays"
                            height="15"
                            rounded
                        >
                            <strong>{{ getEvaluationDiffDays($moment(new Date()).diff(bookCatalog.evaluationDate, 'days')) }}</strong>
                        </v-progress-linear>

                        <!-- tooltip desktop -->
                        <v-tooltip
                            content-class="tooltip tooltip-text"
                            max-width="300"
                            top
                            v-model="showCalendar"
                            >
                            <template v-if="displayDesktop" v-slot:activator="{ on: onCalendar }">
                                <v-btn
                                    class="tooltip-button-hover"
                                    icon
                                    v-on="onCalendar"
                                    >
                                    <v-img
                                        contain
                                        max-height="30"
                                        max-width="30"
                                        class=""
                                        :src="calendarIcon"
                                    ></v-img>
                                </v-btn>
                            </template>
                            <template v-else v-slot:activator="{ on }">
                                <v-btn
                                    class="tooltip-button-hover"
                                    icon
                                    @click="changeSwohCalendar"
                                    >
                                    <v-img
                                        contain
                                        max-height="30"
                                        max-width="30"
                                        class=""
                                        :src="calendarIcon"
                                    ></v-img>
                                </v-btn>
                            </template>
                            <v-row>
                                <v-col cols="12" class="">
                                    {{ $t('home.assignedBook.diffDays.finishAt') }} {{ $moment(bookCatalog.evaluationDate).format('LL') }}
                                </v-col>
                            </v-row>
                        </v-tooltip>
                        <!-- tooltip desktop -->
                        </div>
                    </div>

                    <!--  -->
                    <div class="progress-bar mb-1">
                        <label for="">{{ $t('home.your_progress') }}</label>
                        <div class="progress-bar__container">
                        <v-progress-linear
                            background-color="#514585"
                            color="#C4BBE7"
                            :value="completedTasksPercentage"
                            height="15"
                            rounded
                            v-if="bookCatalog.book"
                        >
                            <strong>{{ bookCatalog.currentPage }} de {{ bookCatalog.book.totalPages }} {{ $t('home.pages') }}</strong>
                        </v-progress-linear>
                        </div>
                    </div>

                    <div class="d-none d-sm-block mt-4">
                        <v-btn
                        outlined
                        color="white"
                        class="border-radius-1 text-transform-none"
                        @click="$router.push(`/user/book/${bookCatalog.book.id}`)"
                        >
                        <v-img
                        :src="require('@/assets/img/icons/book-read.svg')"
                        width="20"
                        height="18"
                        class="mr-2"
                        ></v-img>
                        {{ $t('home.continuous_reading') }}
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" class="pa-0 ma-0" v-if="loading">
                <!-- <v-col cols="12" class="pa-0 ma-0"> -->
                    <v-row class="pa-0 ma-0">
                        <v-col cols="4" md="4">
                            <v-row justify="center">
                                <v-skeleton-loader
                                    class="opacity-none"
                                    height="200"
                                    width="230"
                                    type="image"
                                    :transition="'scale-transition'"
                                ></v-skeleton-loader>
                            </v-row>
                        </v-col>
                        <v-col cols="8" md="8" class="">
                            <v-skeleton-loader
                                class="opacity-none"
                                height="20"
                                width="30%"
                                type="heading"
                                :transition="'scale-transition'"
                            ></v-skeleton-loader>
                            <v-skeleton-loader
                                class="opacity-none my-4"
                                height="20"
                                width="90%"
                                type="heading"
                                :transition="'scale-transition'"
                            ></v-skeleton-loader>
                            <v-skeleton-loader
                                class="opacity-none"
                                height="70"
                                width="90%"
                                type="paragraph"
                                :transition="'scale-transition'"
                            ></v-skeleton-loader>
                            <v-skeleton-loader
                                class="opacity-none mb-3"
                                height="20"
                                width="100%"
                                type="heading"
                                :transition="'scale-transition'"
                            ></v-skeleton-loader>
                            <v-skeleton-loader
                                class="opacity-none"
                                height="20"
                                width="100%"
                                type="heading"
                                :transition="'scale-transition'"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <template v-if="!bookCatalog&&!loading">
            <CarouselCardsEmpty
            :assigned="true"/>
        </template>

    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import CourseBookService from '../../services/courseBook'
import CarouselCardsEmpty from './CarouselCardsEmpty.vue'
import global from '@/constants/GlobalConstant'
export default {
    components: {
        CarouselCardsEmpty
    },
    data() {
        return {
            displayDesktop: true,
            show: false,
            showCalendar: false,
            countClickCalendar: 0,
            bookCatalog: true,
            loading: true,
            knowledge: 10,
            completedTasks: 2,
            totalTasks: 0,
            treasure: require('@/assets/img/icons/treasure-stroke.png'),
            claimReward: require('@/assets/img/icons/claim-reward.png'),
            calendarIcon: require('@/assets/img/icons/calendar-stroke.png'),
            rewards: true
        }
    },
    watch: {
        showCalendar(newValue, oldValue){
            if (newValue && !this.displayDesktop) {
                setTimeout(() => this.showCalendar = false, 3000);
            }
        }
    },
    created () {
        window.innerWidth > 767 ? this.displayDesktop = true : this.displayDesktop = false
        window.addEventListener('resize', this.onResizeButton)
        this.getAssignedBook()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResizeButton)
    },
    computed: {
        ...mapState({
            course: (state) => state.userData.user.course,
            userId: (state) => state.userData.user.id
        }),
        completedTasksPercentage() {
            return (this.bookCatalog.currentPage / this.bookCatalog.book.totalPages) * 100;
        },
        completedTasksPercentageDays() {
            return 100 - ((this.$moment(new Date()).diff(this.bookCatalog.evaluationDate, 'days') / this.$moment(this.bookCatalog.startReadingDate).diff(this.bookCatalog.evaluationDate, 'days')) * 100)
        },
    },
    methods: {
        ...mapActions('userData', ['setExistAssignedBook', 'setAssignedBookId', 'setRemainDays']),
        formatDate(date) {
            const d = new Date(date)
            let month = `${(d.getMonth() + 1)}`
            let day = `${d.getDate()}`
            const year = d.getFullYear()

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join("-");
        },
        getAssignedBook () {
            CourseBookService.getBookListByCourseAndDate({
                userCourseId: this.course.id,
                bookDate: this.formatDate(new Date()),
                userId: this.userId,
            })
            .then((response) => {
                this.setBookAssigment(response.content[0])
                if (response.content[0]) {
                    this.setExistAssignedBook(true)
                    this.setAssignedBookId(response.content[0].id)
                } else {
                    this.setExistAssignedBook(false)
                }
            })
            .catch((error) => console.error(error))
        },
        setBookAssigment (data) {
            this.bookCatalog = data
            this.loading = false
        },
        getEvaluationDiffDays(diff) {
            const absoluteNumber = Math.abs(diff)
            if(diff === 0) {
                return `${this.$t('home.assignedBook.diffDays.remainLess')} 24h`
            }

            if(diff < 0) {
                return `${ this.$t('home.assignedBook.diffDays.remain') } ${absoluteNumber} ${absoluteNumber > 1 ? `${this.$t('home.assignedBook.diffDays.days')}` : `${this.$t('home.assignedBook.diffDays.day')}`}`
            }

            if(diff > 0) {
                return `${this.$t('home.assignedBook.diffDays.finished')} ${absoluteNumber} ${absoluteNumber > 1 ? `${this.$t('home.assignedBook.diffDays.daysAgo')}` : `${this.$t('home.assignedBook.diffDays.dayAgo')}`}`
            }
        },
        changeSwohCalendar() {
            this.showCalendar = !this.showCalendar
            this.countClickCalendar++
        },
        changeGeneralShowCalendar() {
            if (this.countClickCalendar > 1) {
                this.showCalendar = !this.showCalendar
                this.countClickCalendar = 0
            } else {
                this.countClickCalendar++
            }
        },
        onResizeButton() {
            if (window.innerWidth > 767) {
                this.displayDesktop = true
            } else {
                this.displayDesktop = false
            }
        }
    },
}
</script>

<style lang="scss" scoped>

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__button {
    width: 100%;
}
::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__heading {
    height: 100%;
    width: 100%;
}
::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__image {
    height: 100%;
    width: 100%;
}
::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__paragraph {
    height: 100%;
    width: 100%;
}
.bg-purple {
    background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
}
.book-card-carousel{
    border: none;
    border-radius: 12px;
    min-height: 250px;
    padding: 12px;
    @media screen and (max-width: 1366px) {
        min-height: 265px;
    }
    @media screen and (max-width: 1263px) {
        min-height: 270px;
    }
    @media screen and (max-width: 959px) {
      min-height: 250px;
    }
    @media screen and (max-width: 767px) {
      min-height: 235px;
    }
    h4{
        line-height: 110%;
        // @media screen and (min-width: 960px) {
        //     min-height: 2em;
        // }
    }
    p{
        font-size: .8rem;
        line-height: 120%;
    }
}
.cover-img{
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 120px;
    &.empty{
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        border: 2px dashed #EEECF8;
        border-radius: 1em;
    }
    .v-btn{
        background: #EEECF8;
        box-shadow: inset 0px 0px 4px rgba(73, 60, 130, 0.5);
        .v-icon{
            background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

}
.progress-bar{
    label{
        font-size: .8em;
        font-weight: 700;
    }
    &__container{
        position: relative;
    }
    .btn-tresure,
    .tooltip-button-hover{
        position: absolute;
        right: -10px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
    }
    .rewards-icon{
      position: absolute;
      left: 0;
      top: -15px;
    }
}
.tooltip-text{
    max-height: 50px;
}
.v-progress-linear{
  &.v-progress-linear--rounded{
    border-radius: 20px;
  }

}
::v-deep{
  .v-progress-linear__content{
    font-size: .7em;
    line-height: 100%;
    color: #EEECF8;
  }
}
</style>
